export default "__VITE_ASSET__CBXXR7xq__"